import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    userSelect: 'none',
  },
  label: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    color: palette['grey-700'],
  },
  select: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
    padding: `${anatomy['space-8']} ${anatomy['space-16']}`,
    background: colors.primaryBackground,
    borderRadius: anatomy.borderRadiusS,
    outline: `1px solid ${colors.tertiaryBorder}`,
    outlineOffset: '-1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  multipleValue: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-4'],
    color: colors.primaryText,
  },
  selectOpen: {
    outlineColor: colors.accentBorder,
  },
  popover: (minWidth: number | null) => ({
    minWidth: minWidth ?? 'unset',
    maxWidth: minWidth ?? 'unset',
    marginTop: anatomy['space-4'],
  }),
  menuList: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    padding: anatomy['space-4'],
    backgroundColor: colors.primaryBackground,
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '190px',
    overflowY: 'auto',
    '::-webkit-scrollbar': {
      width: '6px',
    },
    '::-webkit-scrollbar-thumb': {
      width: anatomy['size-4'],
      backgroundColor: colors.accentBackground,
      borderRadius: anatomy['size-8'],
      border: '1px solid #f9f9f9',
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    padding: `${anatomy['space-8']} ${anatomy['space-12']}`,
    borderRadius: anatomy.borderRadiusXs,
    ':hover': {
      background: colors.hoverBackground,
    },
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectedItem: {
    color: colors.accentText,
  },
  optionsDivider: {
    width: '100%',
    height: anatomy['space-8'],
    padding: `0 ${anatomy['space-4']}`,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    '::after': {
      content: '""',
      display: 'block',
      width: '100%',
      height: anatomy.borderWidthLight,
      backgroundColor: colors.tertiaryBorder,
    },
  },
  chips: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
    marginTop: anatomy['space-8'],
    flexWrap: 'wrap',
  },
});
